module.exports = __webpack_public_path__ + "img/22_49.c3c8dc65.png";